<template>
  <div>
    <div v-if="$route.path.indexOf('_child') === -1 && $route.path.indexOf('_detail') === -1">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input placeholder="会员手机号" v-model="params.mobile"><el-button slot="append" icon="el-icon-search" @click="numberSearch()"></el-button></el-input>
        </el-col>
      </el-row>
      <el-table :data="list" border style="width: 100%" :height="wheight-170"  v-loading="loading" element-loading-text="数据加载中" :default-sort = "{prop: 'bind_date', order: 'descending'}">
        <el-table-column prop="user_info.username" label="用户名称" min-width="150"></el-table-column>
        <el-table-column prop="user_info.realname" label="真实姓名" min-width="150"></el-table-column>
        <el-table-column prop="mobile" label="会员手机号" min-width="150"></el-table-column>
        <el-table-column prop="extra.card_id" label="卡券id" width="100"></el-table-column>
        <el-table-column prop="extra.title" label="卡券名" width="200"></el-table-column>
        <el-table-column prop="extra.str_title" label="物品名称" width="200"></el-table-column>
        <el-table-column prop="extra.card_type" label="卡券类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.extra.card_type == 'discount'">折扣券</span>
            <span v-if="scope.row.extra.card_type == 'cash'">代金券</span>
            <span v-if="scope.row.extra.card_type == 'gift'">兑换券</span>
          </template>
        </el-table-column>
        <el-table-column prop="extra.get_limit" label="可领数量" width="100"></el-table-column>
        <el-table-column prop="extra.quantity" label="卡券数量" width="100"></el-table-column>
        <el-table-column prop="extra.least_cost" label="起用金额" width="100"></el-table-column>
        <el-table-column prop="extra.reduce_cost" label="减免金额" width="100"></el-table-column>
        <el-table-column prop="extra.begin_date" label="有效期起始时间" width="200">
          <template slot-scope="scope">
           <span>{{scope.row.extra.begin_date | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="extra.end_date" label="有效期结束时间" width="200">
          <template slot-scope="scope">
            <span>{{scope.row.extra.end_date | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="记录时间" width="200">
          <template slot-scope="scope">
            <span>{{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination
          background
          layout="prev, pager, next, total"
          @current-change="handlePage"
          :current-page.sync="params.page"
          :total='total_count'
          :page-size="params.pageSize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getSendcouponlogList } from '../../../../api/promotions'
export default {
  data () {
    return {
      params: {
        page: 1,
        pageSize: 15,
        mobile: ''
      },
      list: [],
      loading: false,
      row: {},
      identifier: '',
      currentRow: null,
      total_count: 0,
      message: '',
      dialogVisible: false
    }
  },
  methods: {
    detail (row) {
      let routeData = this.$router.resolve({ path: this.matchHidePage('detail'), query: {  user_id: row.user_id }});
      window.open(routeData.href, '_blank');
    },
    count (index, row) {
      if(row.children_count > 0) {
        let routeData = this.$router.resolve({ path: this.matchHidePage('child'), query: {  promoter_id: row.promoter_id }});
        window.open(routeData.href, '_blank');
      }
    },
    numberSearch () {
      this.loading = true
      getSendcouponlogList(this.params).then(response => {
        this.list = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
    getSendcouponlogList (params) {
      this.loading = true
      getSendcouponlogList(params).then(res => {
        this.list = res.data.data.list
        this.total_count = Number(res.data.data.total_count)
        this.loading = false
      })
    },
    getExtraList (salespersonId, storetype) {
      this.relShop.relShopVisible = true
      this.relShop.params.salesperson_id = salespersonId
      if (storetype) {
        this.relShop.params.store_type = storetype
      }
    },
    handleCurrentChange (val) {
      this.currentRow = val.user_id
    },
    submitSuperiorAction () {
      this.editPopularizeRemoveFun()
      this.editSuperiorVisible = false
    },
    handlePage (page_num) {
      this.params.page = page_num
      this.getSendcouponlogList(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    }
  },
  mounted () {
    this.getSendcouponlogList(),
      getSendcouponlogList(this.params).then(res => {
        this.gradeList = res.data.data
      })
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  }
}
</script>
<style scoped lang="scss">
.grade-setting-col {
  line-height: 40px;
}
.btn-gap {
  margin-left:10px;
}
//.el-table__body-wrapper::-webkit-scrollbar {
//  width: 8px; /*滚动条宽度*/
//  height: 8px; /*滚动条高度*/
//}
//.el-table__body-wrapper::-webkit-scrollbar-track {
//  border-radius: 10px; /*滚动条的背景区域的圆角*/
//  -webkit-box-shadow: inset 0 0 6px rgba(238,238,238, 0.3);
//  background-color: #eeeeee; /*滚动条的背景颜色*/
//}
//.el-table__body-wrapper::-webkit-scrollbar-thumb {
//  border-radius: 10px; /*滚动条的圆角*/
//  -webkit-box-shadow: inset 0 0 6px rgba(145, 143, 0143, 0.3);
//  background-color: rgb(145, 143, 143); /*滚动条的背景颜色*/
//}
</style>



// WEBPACK FOOTER //
// list.vue?445982d9